import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from 'react';
import { getHotkeyMatcher } from './parse-hotkey.js';
export { getHotkeyHandler } from './parse-hotkey.js';
function shouldFireEvent(event) {
  if (event.target instanceof HTMLElement) {
    return !["INPUT", "TEXTAREA", "SELECT"].includes(event.target.tagName);
  }
  return true;
}
function useHotkeys(hotkeys) {
  useEffect(function () {
    var keydownListener = function keydownListener(event) {
      hotkeys.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          hotkey = _ref2[0],
          handler = _ref2[1];
        if (getHotkeyMatcher(hotkey)(event) && shouldFireEvent(event)) {
          event.preventDefault();
          handler(event);
        }
      });
    };
    document.documentElement.addEventListener("keydown", keydownListener);
    return function () {
      return document.documentElement.removeEventListener("keydown", keydownListener);
    };
  }, [hotkeys]);
}
export { useHotkeys };